<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8.71 7.71L11 5.41V16a1 1 0 002 0V5.41l2.29 2.3a1 1 0 001.41 0 1 1 0 000-1.41l-4-4a1 1 0 00-1.41 0l-4 4a1 1 0 101.42 1.41z"/><path d="M16.22 12.44a1 1 0 00-1.2.75 1 1 0 00.76 1.19C18.55 15 20 16.17 20 17c0 1.22-3.12 3-8 3s-8-1.78-8-3c0-.83 1.45-2 4.22-2.6A1 1 0 009 13.22a1 1 0 00-1.18-.77C4.16 13.25 2 15 2 17c0 2.85 4.3 5 10 5s10-2.15 10-5c0-2-2.16-3.75-5.78-4.56z"/></svg>